export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_08.9b53d657.png";